import { render } from "./SchemesInsightComponent.vue?vue&type=template&id=1536ec41&scoped=true"
import script from "./SchemesInsightComponent.vue?vue&type=script&lang=js"
export * from "./SchemesInsightComponent.vue?vue&type=script&lang=js"

import "./SchemesInsightComponent.vue?vue&type=style&index=0&id=1536ec41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1536ec41"]])

export default __exports__